<template>
    <div>
        <h1>网站地图</h1>
        <ul class="sitemap">
            <li v-for="(item, index) in sitemap" :key="index">
                <router-link v-if="item.path" :to="item.path">{{ item.title }}<br>{{ item.name }}</router-link>
                <span v-else>{{ item.title }}<br>{{ item.name }}</span>
            </li>
        </ul>
        <h1>网站结构及资源权限</h1>
        <ul class="sitemap sitemap--flat-auto">
            <li v-for="([stage, list], index) in stageList" :key="index">
              <div>{{ stage.title }}</div>
              <template v-for="(item, j) in list">
                <dl class="sitemap" :key="item.path+j" :style="`padding-left:${item.level*.5}em`">
                  <dt>
                    <div :is="item.path ? 'router-link':'span'" :to="item.path">
                      {{ item.title }}<br>{{ item.name }}<template v-if="item.permission"><br>{{ item.permissionOn?"已开启限制":"未开启限制" }} | 资源：{{ item.permission }}</template>
                    </div>
                  </dt>
                  <dd v-if="item.children && item.children.length > 0">
                    <template v-for="(sub, g) in item.children">
                        <div v-if="sub.type!=2" :key="sub.title+g" :is="sub.path ? 'router-link':'span'" :to="sub.path">
                          - {{ sub.title }}<br>{{ sub.name }}<template v-if="sub.permission"><br>{{ sub.permissionOn?"已开启限制":"未开启限制" }} | 资源：{{ sub.permission }}</template>
                        </div>
                        <template v-for="(_sub, h) in sub.children">
                            <div :key="_sub.title+h" :is="_sub.path ? 'router-link':'span'" :to="_sub.path">
                              - {{ _sub.title }}<br>{{ _sub.name }}<template v-if="_sub.permission"><br>{{ _sub.permissionOn?"已开启限制":"未开启限制" }} | 资源：{{ _sub.permission }}</template>
                            </div>
                        </template>
                    </template>
                  </dd>
                </dl>
              </template>
            </li>
        </ul>
    </div>
</template>
<style lang="scss" scoped>
.sitemap{
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    list-style: none;
    li{
        width: 25%;
        padding: 10px;
        a,span{
            display: block;
            background-color: #fff;
            padding: 7px 10px;
        }
    }
    &--flat-auto{
      flex-wrap: nowrap;
      li{
        width: auto;
        flex-grow: 1;
      }
    }
}
dl.sitemap{
  display: block;
  background-color: #fff;
  margin-bottom: 1px;
  dt{
    font-weight: bold;
  }
  dd{
    padding: 0 5px;
    a{
      padding: 3px 10px;
    }
  }
}
</style>
<script>
import {flat,findNode} from "@packy-tang/navi-maker";
import { router,getSitemap,getNavigations, getStage } from "@/routes/"

function getPoint(navName){
  let result = sitemap.find(pageConf=>pageConf.name===navName);
  const route = router.resolve({ name: result.name })
  return {
    ...result,
    path: route.route.path,
    permission: route.route.meta.permissions ? Object.keys(route.route.meta.permissions) : "",
    permissionOn: route.route.meta.permissionOn
  }
}

export default {
    data() {
        const navi = getNavigations()
        const sitemap = getSitemap().map(node=>{
          const navi = node.navi||{}
          const route = this.$router.getRoutes().find(i=>i.name==node.name)
          const routeNode = this.$router.resolve({ name: node.name })

          return {
            name: node.name,
            title: navi.title||node.title,
            path: navi.path || (route?routeNode.route.path:''),
            shown: typeof navi.shown == 'undefined' ? true : navi.shown,
          }
        })
        const stageList = getStage().map(stage=>{
          return [
            {title:stage.navi.title,...stage},
            flat([findNode(stage.name, navi)]).map(i=>{
              const route = this.$router.getRoutes().find(item=>i.name==item.name)
              console.log(route)
              if(!route) return i
              return {
                ...i,
                permission: route.meta.permissions ? Object.keys(route.meta.permissions) : "",
                permissionOn: route.meta.permissionOn
              }
            })
          ]
        })
        return {
            sitemap,
            stageList,
            // stageList: Object.keys(stageList).map(stage=>[getPoint(stage), getNavi(stageList[stage])])
        }
    }
}
</script>

